import { useEffect } from 'react';

const usePushSdkLoader = (zoneID = 1553817) => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const clickID = url.searchParams.get('click_id');
    const sourceID = url.searchParams.get('source_id');

    // ✅ MUST set `window.opts` BEFORE loading sdk.js
    window.opts = {
      zoneID: zoneID,
      extClickID: clickID,
      subID1: sourceID,
      actions: {
        onPermissionGranted: () => console.log('🔔 Permission granted'),
        onPermissionDenied: () => console.log('🔕 Permission denied'),
        onAlreadySubscribed: () => console.log('✅ Already subscribed'),
        onError: () => console.log('❌ Push SDK error'),
      },
    };

    // 🚀 Load script AFTER window.opts is ready
    const script = document.createElement('script');
    script.dataset.cfasync = 'false';
    script.src = `https://push-sdk.com/f/sdk.js?z=${zoneID}`;
    script.async = true;

    document.head.appendChild(script);

    // ✅ Clean up (optional)
    return () => {
      delete window.opts;
    };
  }, [zoneID]);
};

export default usePushSdkLoader;
